import styled from 'styled-components'

const MainStyle = styled.main`
  background-color: ${props => (props.shortenedView ? '#f5f5f5' : '#efefef')};
  .ExpansionPanelSummary {
    background: ${props => props.theme.black4};
    padding: 0 12px;

    > div:first-child {
      margin: 9px 0;
    }
  }
  padding-bottom: 16px;
  height: ${props => (props.shortenedView ? 'auto' : '90vh')};
  overflow: auto;
  display: flex;
  flex-direction: column;

  .container {
    justify-self: auto;
  }
`
export default MainStyle
